<Section>
  <form [formGroup]="contactForm">
    <!-- Row 1: Title -->
    <div class="row mb-0 mb-lg-3">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <label class="form-label d-block required-asterisk">
          {{ fieldLabels['account'] || 'Account Name' }}
        </label>
        <!-- Account Name -->
        <p-select 
          [options]="accountNames" 
          formControlName="accountName" 
          optionLabel="value"
          [placeholder]="fieldPlaceholders['account'] || 'Select an account'" 
          class="w-full md:w-56"
          [ngClass]="{ 
            'ng-invalid ng-dirty': isError('accountName') && !isAccountNameDisabled,
            'disabled-field': isAccountNameDisabled 
          }"
          [disabled]="isAccountNameDisabled"
          [showClear]="!!contactForm.get('accountName')?.value">
        </p-select>
        <small *ngIf="isError('accountName')" class="error-label">
          This field is mandatory
        </small>
      </div>
    </div>

    <!-- Row 2: Name and Email -->
    <div class="row mb-0 mb-lg-3">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <label class="form-label d-block required-asterisk">
          {{ fieldLabels['name'] || 'Name' }}
        </label>
        <input pInputText type="text" class="w-100" formControlName="name"
          [placeholder]="fieldPlaceholders['name'] || 'Enter name'"
          [ngClass]="{ 'ng-invalid ng-dirty': isError('name') }" />
        <small *ngIf="isError('name')" class="error-label">
          This field is mandatory
        </small>
      </div>

      <div class="col-sm-6 mb-3 mb-sm-0">
        <label class="form-label d-block required-asterisk">
          {{ fieldLabels['title'] || 'Title' }}
        </label>
        <p-select [options]="titles" formControlName="title" optionLabel="value"
          [placeholder]="fieldPlaceholders['title'] || 'Select a title'" class="w-full"
          (onChange)="onTitleChange($event)"></p-select>
        <small *ngIf="isError('title')" class="error-label">
          This field is mandatory
        </small>
      </div>

    </div>

    <!-- Row 3: Phone and Extension -->
    <div class="row mb-0 mb-lg-3">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <label class="form-label d-block required-asterisk">
          {{ fieldLabels['email'] || 'Email' }}
        </label>
        <input pInputText type="email" class="w-100" formControlName="email"
          [placeholder]="fieldPlaceholders['email'] || 'Enter email'" />
        <small *ngIf="isError('email')" class="error-label">
          This field is mandatory
        </small>
      </div>
      <div class="col-sm-4 mb-3 mb-sm-0">
        <label *ngIf="sourceComponent === 'client-contacts'" class="form-label d-block">
          {{ fieldLabels['phone'] || 'Phone' }}
        </label>
        <label *ngIf="sourceComponent === 'account-contacts'" class="form-label d-block required-asterisk">
          {{ fieldLabels['phone'] || 'Phone' }}
        </label>
        <!-- <input pInputText type="text" class="w-100" formControlName="phone"
          [placeholder]="fieldPlaceholders['phone'] || 'Enter phone'" /> -->
        <p-inputmask mask="(999) 999-9999" id="add-contact-phone-no" placeholder="Enter phone"
          formControlName="phone" class="w-100 phone-inputmask"
          [ngClass]="{'ng-invalid ng-dirty' : isError('phone')}" autocomplete="new-password"/>
        <small *ngIf="isError('phone') && sourceComponent === 'account-contacts'" class="error-label">
          This field is mandatory
        </small>
      </div>

      <div class="col-sm-2 mb-3 mb-sm-0">
        <label class="form-label d-block">
          {{ fieldLabels['extension'] || 'Extension' }}
        </label>
        <input pInputText type="text" class="w-100" formControlName="extension"
          [placeholder]="fieldPlaceholders['extension'] || 'Enter extension'" />
      </div>
    </div>

    <!-- Row 4: Bar Number and Status -->
    <div class="row mb-0 mb-lg-3">
      <div *ngIf="fieldVisibility?.['barNumber'] !== false" class="col-sm-6 mb-3 mb-sm-0">
        <label class="form-label d-block" 
              [ngClass]="{'required-asterisk': !isBarNumberDisabled}">
          {{ fieldLabels['barNumber'] || 'Bar Number' }}
        </label>
        <input pInputText type="text" class="w-100" formControlName="barNumber"
          [placeholder]="fieldPlaceholders['barNumber'] || 'Enter bar number'" />
        <small *ngIf="isError('barNumber') && !isBarNumberDisabled" class="error-label">
          This field is mandatory
        </small>
      </div>

      <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="isEditModeEnabled">
        <label class="form-label d-block">
          {{ fieldLabels['status'] || 'Status' }}
        </label>
        <!-- Status -->
        <p-select 
          [options]="statuses" 
          formControlName="status" 
          optionLabel="value"
          [placeholder]="fieldPlaceholders['status'] || 'Select a status'" 
          class="w-full"
          >
        </p-select>
      </div>
      <div *ngIf="hiddenId">
        <input pInputText type="hidden" class="w-100" formControlName="id" />
      </div>
    </div>
  </form>
</Section>